module.exports = __webpack_public_path__ + "static/media/cert5.486aa41c.jpeg";